// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"cb80743f","37":"324016ff","112":"2c0dfb22","260":"f75eb2a1","423":"a1b2267e","453":"02b75004","476":"ca48307b","494":"50ee193b","833":"ada5ce90","835":"5fbf8bf0","931":"8be4e5fe","984":"1321b24c"}[chunkId] + ".chunk.js";
};